import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button } from '@mui/material';

export default function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        onClick={() => navigate('/blog')}
        sx={{ mb: 2 }}
      >
        ← Back to Blog
      </Button>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          Blog Post #{id}
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          Published on November {id}, 2024
        </Typography>
        <Typography variant="body1" paragraph>
          This is the content of blog post #{id}. In a real application, this would
          be fetched from an API or database.
        </Typography>
        <Typography variant="body1" paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua.
        </Typography>
      </Paper>
    </Container>
  );
}

